/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Interview_Qbank_Seniority_ExecutiveInputs */

const en_interview_qbank_seniority_executive = /** @type {(inputs: Interview_Qbank_Seniority_ExecutiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Executive`)
};

const de_interview_qbank_seniority_executive = /** @type {(inputs: Interview_Qbank_Seniority_ExecutiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Führungskraft`)
};

const fr_interview_qbank_seniority_executive = /** @type {(inputs: Interview_Qbank_Seniority_ExecutiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dirigeant`)
};

const es_interview_qbank_seniority_executive = /** @type {(inputs: Interview_Qbank_Seniority_ExecutiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ejecutivo`)
};

const it_interview_qbank_seniority_executive = /** @type {(inputs: Interview_Qbank_Seniority_ExecutiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Executive`)
};

const nl_interview_qbank_seniority_executive = /** @type {(inputs: Interview_Qbank_Seniority_ExecutiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Executive`)
};

const pl_interview_qbank_seniority_executive = /** @type {(inputs: Interview_Qbank_Seniority_ExecutiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Executive`)
};

const fi_interview_qbank_seniority_executive = /** @type {(inputs: Interview_Qbank_Seniority_ExecutiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Johtaja`)
};

const da_interview_qbank_seniority_executive = /** @type {(inputs: Interview_Qbank_Seniority_ExecutiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Direktør`)
};

const sv_interview_qbank_seniority_executive = /** @type {(inputs: Interview_Qbank_Seniority_ExecutiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Direktör`)
};

/**
* | output |
* | --- |
* | "Executive" |
*
* @param {Interview_Qbank_Seniority_ExecutiveInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const interview_qbank_seniority_executive = /** @type {((inputs?: Interview_Qbank_Seniority_ExecutiveInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Qbank_Seniority_ExecutiveInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_qbank_seniority_executive(inputs)
	if (locale === "fr") return fr_interview_qbank_seniority_executive(inputs)
	if (locale === "es") return es_interview_qbank_seniority_executive(inputs)
	if (locale === "it") return it_interview_qbank_seniority_executive(inputs)
	if (locale === "nl") return nl_interview_qbank_seniority_executive(inputs)
	if (locale === "pl") return pl_interview_qbank_seniority_executive(inputs)
	if (locale === "fi") return fi_interview_qbank_seniority_executive(inputs)
	if (locale === "da") return da_interview_qbank_seniority_executive(inputs)
	if (locale === "sv") return sv_interview_qbank_seniority_executive(inputs)
	return en_interview_qbank_seniority_executive(inputs)
});